﻿'use strict'

var jquery = require('jquery');
global.$ = global.jQuery = jquery;      // To get the jQuery object in the global scope because Bootstrap 4 doesn't do modules properly
module.exports = (function () {

    // private methods


    // public methods

    /**
    * @ngdoc method
    * @name initializeTestimonial
    * @description setup the testimonial slider
    **/
    var initializeTestimonial = function () {

        var $pageNumber = 1;
        var $loading = false;
        $(window).on('scroll', function () {
            var $testimonials = $('#testimonials');

            // Check if testimonials element exists
            if ($testimonials.length && ($pageNumber == 1 || !$loading)) {
                var scrollTop = $(window).scrollTop(); // Get current scroll position
                var windowHeight = $(window).height(); // Get height of the window
                var testimonialsOffsetTop = $testimonials.offset().top; // Top offset of the testimonials section
                var testimonialsHeight = $testimonials.outerHeight(); // Height of the testimonials section
                var $testimonialsSpinner = $('.testimonials-spinner');

                // Condition: When user scrolls near the bottom of testimonials section
                if (scrollTop + windowHeight >= testimonialsOffsetTop + testimonialsHeight - 500) {
                    $loading = true;
                    $testimonialsSpinner.show();
                    // Ensure you have more pages to load
                    $pageNumber = $pageNumber + 1;
                    if ($pageNumber <= $totalpages) {
                        LoadTestimonials($pageNumber, $testpagesize, $locationmarket);
                    }
                    else { $testimonialsSpinner.hide(); }
                }

                if (scrollTop + windowHeight >= 2000) {
                    $('.mw-back-to-top').show();
                } else {
                    $('.mw-back-to-top').hide();
                }
            }
        });
        function LoadTestimonials(pageNumber, pageSize, localtionmarket) {
            var $testimonialsSpinner = $('.testimonials-spinner');
            $.ajax({
                type: 'GET',
                url: '/umbraco/Surface/TestimonialSurface/All',
                data: { pageNumber: pageNumber, pageSize: pageSize, locationmarket: localtionmarket },
                success: function (result) {
                    $("#testimonials").append(result);
                    $loading = false;
                    $testimonialsSpinner.hide();
                }
            });
            // hide the spinner if call fails even
            $testimonialsSpinner.hide();
        }
    };


    // Return an object exposing the public items
    return {
        initialize: initializeTestimonial
    };
}());